.ad{min-width:0px;}